<template>
    <section>
        <sy-baselist
                hideAdd
                hideOperate
                :filters="filters"
                listUrl="server/system/Log.ashx?cmd=GetList"
        >
            <el-table-column prop="FOperator" label="操作类型" width="120" sortable>
            </el-table-column>
            <el-table-column prop="FContent" label="内容" width="400" sortable>
            </el-table-column>
            <el-table-column prop="FUserName" label="操作者" width="150" sortable>
            </el-table-column>
            <el-table-column prop="FCreateDate" label="操作时间" :formatter="formatDate2" width="200" sortable>
            </el-table-column>

        </sy-baselist>
    </section>
</template>

<script>
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    export default {
        mixins: [mixin],
        data(){
            return {
                filters: [{type: "string",name:"FUserName",text:"操作者", value: ""},
                    {type: "date",name:"FCreateDate",text:"操作时间", value: null}
                ]
            }
        },
        methods:{
            //合并列
            //:SpanMethod="cellMerge"
           //@onLoadData="getSpanArr"
          getSpanArr(data) {
              this.spanArr=[],
              this.spanArr1=[]
            for (var i = 0; i < data.length; i++) {
              if (i === 0) {
                this.spanArr.push(1);
                this.spanArr1.push(1);
                this.pos = 0
                this.pos1=0
              } else {
                // 判断这一条和上一条操作类型是否相同
                if (data[i].FOperator === data[i - 1].FOperator) {
                  this.spanArr[this.pos] += 1;
                  this.spanArr.push(0);
                } else {
                  this.spanArr.push(1);
                  this.pos = i;
                }

                if (data[i].FContent === data[i - 1].FContent) {
                  this.spanArr1[this.pos1] += 1;
                  this.spanArr1.push(0);
                } else {
                  this.spanArr1.push(1);
                  this.pos1 = i;
                }
              }
            }
          },

          cellMerge({ row, column, rowIndex, columnIndex }) {
            //第一列
            if (columnIndex === 0) {
              var _row = this.spanArr[rowIndex];
              var _col = _row > 0 ? 1 : 0;
              return {
                rowspan: _row,
                colspan: _col
              }
            }
            if (columnIndex === 1) {
              var _row1 = this.spanArr1[rowIndex];
              var _col1 = _row1 > 0 ? 1 : 0;
              return {
                rowspan: _row1,
                colspan: _col1
              }
            }
          },
          exportExcel(){

          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/system/Log.vue